// test1572
(1572 && 0);
